import { useReactiveVar } from '@apollo/client';
import React, { useContext, useEffect } from 'react';

import { ListNotificationRootStyled } from './styles/ListNotificationComponentStyles';
import { notificationsVar } from '../../../cache/cache';
import { NotificationContext } from '../../../contexts/NotificationsContext';
import NotificationComponent from '../NotificationComponent/NotificationComponent';

const ListNotificationComponent: React.FC = () => {
  const { contentData, setShowNotification } = useContext(NotificationContext);
  const notifications = useReactiveVar(notificationsVar);
  const { listNotifications } = contentData;

  useEffect(() => {
    if (notifications.length) {
      setShowNotification(true);
    }
  }, [notifications]);

  const hasNotifications = (listNotifications?.length || notifications.length) > 0;

  return (
    <ListNotificationRootStyled data-testid="ListNotification" data-visible={String(hasNotifications)}>
      {listNotifications.map((notification, index: number) => (
        <NotificationComponent key={`${index.toString()} - ${notification.id}`} {...notification} />
      ))}
      {notifications.map((notification, index: number) => (
        <NotificationComponent key={`${index.toString()} - ${notification.id}`} {...notification} />
      ))}
    </ListNotificationRootStyled>
  );
};

export default ListNotificationComponent;
